// Ideally we want to do this:
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';

// But due to the bug mentioned in ./base we do this:
//import Model from './base';
//import { attr, belongsTo, hasMany } from '@ember-data/model';

import { tracked } from '@glimmer/tracking';
import { sort, alias } from '@ember/object/computed';

export default class BounceModel extends Model {
  @belongsTo('project-version', { inverse: 'bounces', async: false })
  projectVersion;
  @belongsTo('project', { inverse: 'bounces', async: false }) project;
  @belongsTo('user', { inverse: null, async: false }) user;
  @hasMany('comment', { inverse: 'bounce', async: false }) comments;
  @attr('string') checksum;
  @attr('string') fileName;
  @attr('boolean') uploadComplete;
  @attr() sizeInBytes;
  @attr() signedUploadData;
  @attr() peaks;
  @attr() downloadUrl;

  @tracked percentPlayed = 0;

  createdAtSorting = ['createdAt:asc'];
  @sort('comments', 'createdAtSorting') sortedComments;
  @alias('sortedComments') sortedActivityComments;

  get duration() {
    return this.peaks.length / 5 / 2;
  }

  identifier() {
    if (this) {
      return this.downloadUrl;
    } else {
      return null;
    }
  }

  get soundId() {
    return `bounce_${this.id}`;
  }
}
